import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { University } from '../shared/models/university.model';
import { ApiService } from './api.service';
import { GenericApiResponse } from '../interfaces/api';

@Injectable({
  providedIn: 'root',
})
export class UniService {
  public errorMsg = '';

  constructor(
    private readonly http: HttpClient,
    private readonly api: ApiService
  ) {}

  public createUniversity(uni: University) {
    const endpoint = `${this.api.url}/universities`;

    return this.http.post(endpoint, uni);
  }

  public getUniversityBySlug(uni: string) {
    const endpoint = `${this.api.url}/universities/slug/${uni}`;
    return this.http.get(endpoint);
  }

  public searchUniversities(searchTerm: string) {
    const endpoint = `${this.api.url}/universities/search`;

    const params = new HttpParams()
      .set('searchTerm', searchTerm)
      .set('page', 1)
      .set('perPage', 999);

    return this.http.get(endpoint, { params });
  }

  public getUniversitiesGroupedByLetter(start: string, end: string) {
    const endpoint = `${this.api.url}/universities/letter-group/${start}-${end}`;

    const params = new HttpParams().set('page', 1).set('perPage', 999);

    return this.http.get(endpoint, { params });
  }

  public getUniversityByCmsUID(uid: string) {
    const endpoint = `${this.api.url}/universities/cms-uid/${uid}`;
    return this.http.get(endpoint);
  }

  public getUniversityByUUID(uuid: string) {
    const endpoint = `${this.api.url}/universities/${uuid}`;
    return this.http.get(endpoint);
  }

  public getImNotAtUniversityObject() {
    return this.getUniversityBySlug('im-not-at-university');
  }

  public checkIsUnihomes(
    universityUid: string
  ): Observable<GenericApiResponse<ICheckIsUnihomeResponse>> {
    const endpoint = `${this.api.url}/universities/check-is-unihome/${universityUid}`;
    return this.http.get<GenericApiResponse<ICheckIsUnihomeResponse>>(endpoint);
  }
}

export interface ICheckIsUnihomeResponse {
  is_unihome_product: boolean;
  registration_carousel_uid: string;
}
